import { Runtime } from "@morphism/fp";
import React from "react";

import { Time } from "~/Time";
import { User } from "~/User";

export type Created = { readonly created: Time.DateTime & Partial<User> };
export function Created({ created }: Created) {
  const user = created.user && (
    <>
      Created by <User user={created.user} /> at&nbsp;
    </>
  );

  return (
    <>
      {user}
      <Time.DateTime {...created} />.
    </>
  );
}

export namespace Created {
  export namespace Response {
    export const runtime = () =>
      Runtime.strict({
        create_date: Runtime.nullable(Time.DateTime.Response.runtime()),
        created_by: Runtime.nullable(User.Response.runtime()),
      });

    export const decode = (
      response: Runtime.ToType<typeof runtime>
    ): Created | undefined =>
      response.create_date?.dateTime === undefined || !response.created_by
        ? undefined
        : {
            created: {
              ...response.create_date,
              ...User.Response.decode(response.created_by),
            },
          };
  }
}
